module.exports = __webpack_public_path__ + "media/icons/roadpass-9617564a.png";